import { render, staticRenderFns } from "./EditOrganisationUserModal.vue?vue&type=template&id=30449736"
import script from "./EditOrganisationUserModal.vue?vue&type=script&lang=ts"
export * from "./EditOrganisationUserModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports